import { Controller } from 'stimulus';
import cookie from '../helpers/cookie';

class CartReminderController extends Controller {
  connect() {
    if (!this.hasModalTarget) {
      return;
    }

    this.openModal();
  }

  emptyCart() {
    window.axios.post('api/journey-cart/empty')
      .then(() => {
        this.closeModal();
      });
  }

  continue() {
    this.closeModal();
  }

  openModal() {
    $(this.modalTarget).modal('show');
  }

  closeModal() {
    cookie.set('cart-reminder-closed', true, 24 * 60 * 60);

    $(this.modalTarget).modal('hide');
  }
}

CartReminderController.targets = [
  'modal',
];

export default CartReminderController;
